import { Nullable } from '@/utils/types';
import { formatDate } from '@/utils/filters';

export function getDateAvailableLabel (dateAvailable: Nullable<string>): string {
  if (!dateAvailable) return '';

  if (new Date(dateAvailable) <= new Date()) {
    return `Now (${formatDate(dateAvailable)})`;
  }

  return formatDate(dateAvailable) as string;
}
